import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NotificacoesService } from '../../../services/notificacoes.service';
import { Notificacao } from '../../../aplicacao/models/notificacao.model';
import { UtilsHelper } from '../../../aplicacao/helper/utils.helper';
import { Fases } from '../../../aplicacao/enum/tipo-fase.enum';
import { ComunicacaoService } from '../../../services/comunicacao.service';

@Component({
  selector: 'app-notificacao-sino',
  templateUrl: './notificacao-sino.component.html',
  styleUrls: ['./notificacao-sino.component.scss']
})
export class NotificacaoSinoComponent implements OnInit, OnDestroy {

  notificacoes: Notificacao[] = [];
  contador = 0;
  painelAberto = false;

  private utils = new UtilsHelper();
  private subs: Subscription[] = [];

  /** Mapeamento entre a fase recebida na notificação e a rota correspondente do menu lateral */
  private readonly rotasPorFase: { [key: string]: string[] } = {
    [Fases.PropostasPendentes]: ['/area-parceiro/cotacoes/propostas-pendentes'],
    [Fases.AguardandoProposta]: ['/area-parceiro/cotacoes/aguardando-propostas'],
    [Fases.AceitasEnvioDeDocumentos]: ['/area-parceiro/cotacoes/aceitas/aguardando-parceiros'],
    [Fases.AceitasValidandoDocumentos]: ['/area-parceiro/cotacoes/aceitas/aguardando-pjus'],
    [Fases.NegociacaoParceiro]: ['/area-parceiro/cotacoes/em-negociacao/aguardando-parceiro/listagem'],
    [Fases.Negociacao]: ['/area-parceiro/cotacoes/em-negociacao/aguardando-pjus/listagem'],
    [Fases.Vencidas]: ['/area-parceiro/cotacoes/em-negociacao/vencidas/listagem'],
    [Fases.DisponibilidadeDeLeads]: ['/area-parceiro/cotacoes/disponibilidade-leads'],
    [Fases.Pagas]: ['/area-parceiro/operacoes/propostas-pagas'],
    [Fases.Aprovadas]: ['/area-parceiro/operacoes/em-andamento'],
    [Fases.AguardandoIntegracao]: ['/area-parceiro/operacoes/em-andamento'],
    [Fases.Reprovadas]: ['/area-parceiro/cotacoes/canceladas'],
  };

  constructor(
    private notificacoesService: NotificacoesService,
    private router: Router,
    private comunicacaoService: ComunicacaoService
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.notificacoesService.notificacoes$.subscribe(notifs => {
        this.notificacoes = (notifs || []).slice().sort((a, b) =>
          new Date(b.dataCriacao).getTime() - new Date(a.dataCriacao).getTime()
        );
        this.atualizarContador();
      })
    );
    // O carregamento agora ocorre apenas ao abrir o painel (clique no sino)
    // ou logo após o login. Não disparamos mais carregamento aqui.
  }

  abrirPainel(): void {
    this.painelAberto = true;
    // Recarrega as notificações somente quando o usuário clica no ícone do sino
    this.notificacoesService.recarregar();
  }

  fecharPainel(): void {
    if (this.painelAberto) {
      this.notificacoes.forEach(n => n.visualizado = true);
      this.atualizarContador();
      this.painelAberto = false;
    }
  }

  /** Redireciona para a rota mapeada de acordo com a fase da notificação */
  abrirNotificacao(notif: Notificacao): void {
    notif.visualizado = true;
    this.atualizarContador();

    // Notifica o backend que a notificação foi visualizada/clicada
    if (notif?.id) {
      this.notificacoesService.notificar(notif.id).subscribe({
        error: err => console.warn('[NotificacaoSino] falha ao notificar clique:', err)
      });
    }

    const rota = notif.fase ? this.rotasPorFase[notif.fase] : null;
    console.log('[NotificacaoSino] clique notificação:', notif, 'rota destino:', rota);
    if (rota) {
      // Define a proposta que deve ser destacada na listagem destino
      this.comunicacaoService.definirPropostaDestaque(notif.propostaId || null);
      // Pré-preenche o filtro de documento do credor na listagem destino
      this.comunicacaoService.definirDocumentoCredorFiltro(notif.documentoCredor || null);
      this.painelAberto = false;
      this.router.navigate(rota);
    }
  }

  possuiRedirecionamento(notif: Notificacao): boolean {
    return !!(notif?.fase && this.rotasPorFase[notif.fase]);
  }

  private atualizarContador(): void {
    this.contador = this.notificacoes.filter(n => !n.visualizado).length;
  }

  formatarDocumento(documento: string): string {
    return this.utils.cpfCnpj(documento);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}


